import React from 'react';

export default function Collapse({ trigger, open, children, classes = '' }) {
    return (
        <>
            <button
                className={`btn btn--collapse btn-block ${!open && 'collapsed'} ${classes}`}
                data-toggle="collapse"
                data-target={`#${trigger.replace(/[\W_]/g, '')}`}
                aria-expanded="false"
                aria-controls={trigger.replace(/[\W_]/g, '')}
                type="button">
                {trigger}
            </button>
            <div className={`collapse ${open && 'show'}`} id={trigger.replace(/[\W_]/g, '')}>
                <div className="collapse__wrapper mt-4">{children}</div>
            </div>
        </>
    );
}
